import React, { useState, useRef, useImperativeHandle } from "react";
import { Popconfirm, Tooltip, theme } from "antd";
import { DeleteOutlined, EditOutlined, PlusCircleFilled } from "@ant-design/icons";
import TSTable from "../../../common/TSTable";
import ColorButton from "../../../common/ColorButton";
import { DELETE } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import AddSkimModal from "./AddSkimModal";
import { dateTimeToHumanString } from "../../../frameworks/Util";
import ErrorMessages from "../../../common/ErrorMessages";
import CustomDeleteConfirmButton from "../../../common/CustomDeleteConfirmButton";

const SkimList = React.forwardRef((props, ref) => {
  const { isDone } = props;
  const [openAddSkimModal, setOpenAddSkimModal] = useState(false);
  const [target, setTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages , setErrorMessages]= useState(null);

  const convertProductType = (type) => {
    switch (type) {
      case "concentrate_latex":
        return "น้ำยางข้น";
      case "skim":
        return "สกิม";
      default:
        return type;
    }
  };

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  useImperativeHandle(ref, () => ({
    fetchTable: refreshData,
  }));

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessages (error.errorMessages);
      }
    }
  };
  const handleEdit = (record) => {
    if (!record || !record.id) {
      return;
    }
    setTarget(record);
    setOpenAddSkimModal(true);
  };

  const handleDelete = async (id) => {
    if (!id) {
      return;
    }
    setErrorMessages(null);
    try {
      await DELETE(`${URL_SETTING.PRODUCT}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages (error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) => isDone ? null : (
        <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
          <Tooltip triger='hover' title="แก้ไขข้อมูล">
            <ColorButton
              type="primary"
              override={colorWarning}
              style={{ margin: 5 }}
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
        </div>
      )
    },
    {
      title: "ชื่อสินค้า (สกิม)",
      dataIndex: "name",
      key: "name",
      searcher : true,
      align: "center",
    },
    {
      title: "ชื่อย่อ",
      dataIndex: "short_name",
      key: "short_name",
      searcher : true,
      align: "center",
    },
    {
      title: "น้ำหนัก (kg)/ก้อน",
      dataIndex: "weight",
      key: "weight",
      align: "center",
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      ellipsis: true,
      align: "center",
      render: (value) => dateTimeToHumanString(value),

    },
    {
      title: "วันที่แก้ไขล่าสุด",
      dataIndex: "updated",
      key: "updated",
      ellipsis: true,
      align: "center",
      render: (value) => dateTimeToHumanString(value),
    },
  ];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type="primary"
        override={colorSuccess}
        icon={<PlusCircleFilled />}
        style={{ marginBottom: 10, float: "right" }}
        onClick={() => setOpenAddSkimModal(true)}
      >
        เพิ่มสินค้าสกิม
      </ColorButton>

      <TSTable
        columns={columns}
        size="small"
        url={`${URL_SETTING.PRODUCT}?type=skim`}
        ref={tableRef}
      />
      <AddSkimModal
        open={openAddSkimModal}
        onClose={() => {
          setOpenAddSkimModal(false);
          setTarget(null);
        }}
        onUpdate={() => { 
          setOpenAddSkimModal(false);
          setTarget(null);
          refreshData(); 
        }}
        target={target}
      />
    </div>
  );
});

export default SkimList;
